import React from 'react';
import {
    Form, Row, Col, Input, Select, Button, InputNumber,Icon
} from 'antd';
import img from './../../assets/img/Illustration.png';
const { Option } = Select;
class INA extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            plans: [],
        }
    }
    remove = k => {
        const { form } = this.props;
        const keys = form.getFieldValue('keys');
        if (keys.length === 1) {
            return;
        }
        form.setFieldsValue({
            keys: keys.filter(key => key !== k),
        });
    };
    add = () => {
        const { form } = this.props;
        const keys = form.getFieldValue('keys');
        const nextKeys = keys.concat(key => key++);
        form.setFieldsValue({
            keys: nextKeys,
        });
    };
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.submitHandler(values);
            }
        });
    };
    onChange = (e) => {
        this.setState({
            plans: this.props.inv_clients.filter(x => x.id === e)[0].children
        })
    }
    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        getFieldDecorator('keys', { initialValue: [] });
        const keys = getFieldValue('keys');
        const formItems = keys.map((k, index) => (
            <Row key={index} span={24}>
                <Col md={12} sm={24}>
                    <Form.Item
                        required={false}
                        key={k}
                    >
                        <fieldset className="mi_input_pop">
                            <legend className="legend-font">Client</legend>
                            {getFieldDecorator(`client_id[${index}]`, {
                                validateTrigger: ['onChange', 'onBlur'],
                                rules: [
                                    {
                                        required: true,
                                        message: "Please select a Cleint.",
                                    },
                                ],
                            })(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input" onChange={this.onChange}
                                placeholder="Please Select Client">
                                {this.props.inv_clients.map(tag => <Option value={tag.id} key={tag.id}>{tag.name}</Option>)}
                            </Select>)}
                        </fieldset>
                    </Form.Item>
                </Col>
                <Col md={12} sm={24}>
                    <Form.Item
                        required={false}
                        key={k}
                    >
                        <fieldset className="mi_input_pop">
                            <legend className="legend-font">Plan</legend>
                            {getFieldDecorator(`plan_id[${index}]`, {
                                validateTrigger: ['onChange', 'onBlur'],
                                rules: [
                                    {
                                        required: true,
                                        message: "Please select a Plan.",
                                    },
                                ],
                            })(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input"
                                placeholder="Please Select Plan">
                                {this.state.plans.map(tag => <Option value={tag.name} key={tag.name}>{tag.name}</Option>)}
                            </Select>)}
                        </fieldset>
                    </Form.Item>
                </Col>
                <Col md={9} sm={24}>
                    <Form.Item
                        required={false}
                        key={k}
                    >
                        <fieldset className="mi_input_pop">
                            <legend className="legend-font">Adjustment Type</legend>
                            {getFieldDecorator(`Trans_type_desc[${index}]`, {
                                validateTrigger: ['onChange', 'onBlur'],
                                rules: [
                                    {
                                        required: true,
                                        message: "Please select a Description.",
                                    },
                                ],
                            })(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input"
                                placeholder="Please Select Adjustment Type">
                                {this.props.trans_type_desc.map(tag => <Option value={tag.id} key={tag.id}>{tag.name}</Option>)}
                            </Select>)}
                        </fieldset>
                    </Form.Item>
                </Col>
                <Col md={9} sm={24}>
                    <Form.Item required={false}
                        key={k}>
                        <fieldset className="mi_input_pop">
                            <legend className="legend-font">Transaction Note</legend>
                            {getFieldDecorator(`Trans_desc[${index}]`, {
                                validateTrigger: ['onChange', 'onBlur'],
                                rules: [
                                    {
                                        required: true,
                                        message: "Please enter Transaction Note.",
                                    },
                                ],
                            })(<Input autoComplete={"nope"}  className="mi_input" type="text" placeholder='Transaction Note'/>
                            )}
                        </fieldset>
                    </Form.Item>
                </Col>
                <Col md={6} sm={24}>
                    <Form.Item required={false}
                        key={k}>
                        <fieldset className="mi_input_pop">
                            <legend className="legend-font">Amount</legend>
                            {getFieldDecorator(`Trans_amt[${index}]`, {
                                validateTrigger: ['onChange', 'onBlur'],
                                rules: [
                                    {
                                        required: true,
                                        message: "Please enter Amount.",
                                    },
                                ],
                            })(<InputNumber autoComplete={"nope"}  className="mi_input" type="text" placeholder='Amount' />
                            )}
                        </fieldset>
                    </Form.Item>
                </Col>
                <Col md={1} sm={24}>
                    {keys.length > 1 ? (
                        <i className="fa fa-2x fa-minus-circle" style={{ marginTop: '44px', float: 'right' }}
                            onClick={() => this.remove(k)}
                            aria-hidden="true"></i>
                    ) : null}
                </Col>
            </Row>
        ));
        return (
            <div className="mi_model_popup">
                <Row span={24}>
                    <Col span={18}>
                        <p className='mi_title'>{this.props.title}</p>
                    </Col>
                    <Col span={6}>
                        <i className="fa fa-times mi_icon mi_icon_red mi_button_close" style={{ color: 'red' }} onClick={this.props.closeDrawerHandler} ></i>
                    </Col>
                </Row>
                <Row span={24}>
                    <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
                        {formItems}
                        <Form.Item >
                            <Button type="dashed" onClick={this.add} style={{ width: '100%' }}>
                                <i className="fa fa-plus" aria-hidden="true"></i> Add Transaction
                               </Button>
                        </Form.Item>
                        <Row span={24} style={{ marginTop: '20px' }}>
                            <Col span={7} ></Col>
                            <Col span={5} >
                                <Button className="mi_button_right" onClick={this.props.closeDrawerHandler} style={{ marginRight: 8 }}>
                                    Cancel
                          </Button>
                            </Col>
                            <Col span={5} >
                                <Button htmlType="submit" type="primary">
                                    Submit
                      </Button>
                            </Col>
                            <Col span={7} >
                                <img alt="example" style={{ width: 105, marginBottom: '-20px', float: 'right' }} src={img} />
                            </Col>
                        </Row>
                    </Form>
                </Row>
            </div>
        );
    }
}
const InvoiceAdjustmentFrom = Form.create()(INA);
export default InvoiceAdjustmentFrom;